var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toolbar" }, [
    _c("div", { staticClass: "buttons" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-outline-success text-success",
          attrs: {
            type: "button",
            disabled: _vm.isLoading || _vm.disableBtn,
            id: "qeditor-save",
          },
          on: { click: _vm.onSave },
        },
        [_vm._v("\n      保存\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "save-message" }, [
      !_vm.isLoading
        ? _c(
            "span",
            {
              class: {
                "text-success": !_vm.hasError,
                "text-danger": _vm.hasError,
                "hide-message": this.notDisplay,
              },
            },
            [_vm._v(_vm._s(_vm.saveMessage))]
          )
        : _c(
            "span",
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", color: "green" },
              }),
            ],
            1
          ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }